import { render } from "./loading-wrapper.vue?vue&type=template&id=983c42c2&ts=true"
import script from "./loading-wrapper.vue?vue&type=script&lang=ts"
export * from "./loading-wrapper.vue?vue&type=script&lang=ts"

import "./loading-wrapper.vue?vue&type=style&index=0&id=983c42c2&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__